/**
 * This file is AUTO-GENERATED by tools/src/graphql-codegen/generate-register-operation-variables.ts
 * DO NOT EDIT MANUALLY.
 */
import { registerOperationVariables } from "@myvp/shared/src/functions/sanitize-graphql-input"
import sharedOperationVariables from "@myvp/shared/src/gql/operation-variables.json"
import eproViewerOperationVariables from "@myvp/epro-viewer/src/gql/operation-variables.json"
import studyPreviewOperationVariables from "@myvp/study-preview/src/gql/operation-variables.json"
import operationVariables from "src/gql/operation-variables.json"

registerOperationVariables(sharedOperationVariables)
registerOperationVariables(eproViewerOperationVariables)
registerOperationVariables(studyPreviewOperationVariables)
registerOperationVariables(operationVariables)
